import { Button, Group, Modal, PinInput, Stack, Text } from "@mantine/core";
import { IconPlus, IconPointerUp } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useDisclosure } from "@mantine/hooks";
import BackButton from "../../../../components/View/BackButton";
import { useLayoutEffect, useState } from "react";
import { joinTeam } from "../../../../api/UserAPI";
import { notifications } from "@mantine/notifications";

const CreateTeamButton = ({ setTableLoading }) => {
  const lang = useLanguage((s) => s.language);
  const route = `/settings/teams/create`;

  const [opened, { open, close }] = useDisclosure();
  const [loading, setLoading] = useState(false);
  const [codeError, setCodeError] = useState(null);

  const handleJoin = (e) => {
    e.preventDefault();
    const fd = new FormData(e.target);
    const data = Object.fromEntries(fd);

    setLoading(true);
    joinTeam(data.pin)
      .then((response) => {
        setTableLoading(true);
        notifications.show({
          message: lang.teams.row_highlight.duplicated,
          color: "tertiary.8",
        });
        close();
      })
      .catch((err) => {
        let message = err.response.data.state_message;
        document.getElementById("code-input").focus();
        if (message === "already_in_the_team") {
          setCodeError(lang.errors.helper_texts.alreadyInTeam);
        } else if (
          message === "empty_team_code" ||
          message === "team_code_invalid" ||
          message === "team_does_not_exist"
        ) {
          setCodeError(lang.errors.helper_texts.incorrectCode);
        } else if (message === "too_many_attempts") {
          setCodeError(lang.errors.helper_texts.tooManyAttempts);
        } else {
          document.getElementById("code-input").focus();
          setCodeError(lang.errors.helper_texts.incorrectCode);
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const [code, setCode] = useState("");
  const [invited, setInvited] = useState(false);
  useLayoutEffect(() => {
    const params = new URLSearchParams(location.search);
    let code = params.get("code");

    if (code) {
      setInvited(true);
      open();
      setCode(code);
    }
  }, []);

  return (
    <>
      <Group gap={"xl"}>
        <Button
          leftSection={<IconPointerUp size={18} />}
          radius={"md"}
          variant="light"
          color="primary"
          onClick={open}
          size="md"
        >
          {lang.teams.join.button_tooltip}
        </Button>

        <Button
          leftSection={<IconPlus size={18} />}
          radius={"md"}
          color="primary"
          component={Link}
          to={route}
          size="md"
        >
          {lang.teams.create.button_tooltip}
        </Button>
      </Group>

      <Modal
        opened={opened}
        title={lang.teams.join.dialog.title}
        onClose={close}
        size={"md"}
      >
        <Stack component={"form"} onSubmit={handleJoin}>
          {invited ? (
            <Text size="sm">{lang.teams.invited_text}</Text>
          ) : (
            <Text size="sm">{lang.teams.join_text}</Text>
          )}
          <PinInput
            length={6}
            name="pin"
            value={code}
            onChange={setCode}
            error={codeError}
            id="code-input"
            data-autofocus
            fw={600}
            autoFocus
          />

          <Group justify="end" mt={"md"}>
            <BackButton onClick={close} />

            <Button
              leftSection={<IconPointerUp size={18} />}
              color="tertiary.8"
              type="submit"
              loading={loading}
            >
              {lang.teams.join.dialog.submit_button}
            </Button>
          </Group>
        </Stack>
      </Modal>
    </>
  );
};

export default CreateTeamButton;
